<template>
  <div>
    <v-list
      v-if="Array.isArray(answer.answer)"
      color="white"
    >
      <v-list-item
        v-for="item in answer.answer"
        :key="item.id"
        dense
        class="pa-0"
      >
        <v-list-item-icon class="mr-1">
          <v-icon
            color="grey"
          >
            mdi-checkbox-marked-outline
          </v-icon>
        </v-list-item-icon>{{ item }}
      </v-list-item>
    </v-list>
    <v-list v-else-if="question.question_type.type === 'signature-combined' || question.question_type.type === 'signature'">
      <v-list-item
        dense
        class="pa-0"
      >
        <img
          width="60%"
          :src="getImage(answer.answer)"
          position="left"
        >
      </v-list-item>
      <v-list-item
        v-if="answer.answer.full_name"
        dense
        class="pa-0"
      >
        {{ answer.answer.full_name }}
      </v-list-item>
      <v-list-item
        dense
        class="pa-0"
      >
        {{ answer.answer.date }}
      </v-list-item>
    </v-list>
    <span v-else>{{ answer.answer }}</span>
  </div>
</template>
<script>
export default {
  name: 'CandidateAnswerDataComponent',
  props: {
    answer: {
      type: Object,
      default: () => {
        return {}
      }
    },
    question: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => ({
    //
  }),
  computed: {
    storageRoot () {
      return process.env.MIX_STORAGE_URL
    }
  },
  created () {
    //
  },
  methods: {
    getImage (imgPath) {
      if (imgPath.url) {
        imgPath = imgPath.url
      }
      const lastSlashIndex = imgPath.lastIndexOf('/')
      let fileName = imgPath.substring(lastSlashIndex + 1)
      // Remove the trailing "}" from the file name. Not sure where it comes from.
      fileName = fileName.replace('"}', '')
      return window.location.origin + '/show-signature/' + fileName
    }
  }
}
</script>
